/**
 * @description 准时交货率
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <span class="rate">准时交货率</span>
      <span class="target">目标：高于 97%</span>
    </div>
    <div class="main">
      <div class="detalis1">
        <div class="item-cell date">
          <span class="day">时间范围：{{ onTimeDelivery.duration }}天</span>
          <span>{{ onTimeDelivery.timeFrameStart | convertToDate}} - {{ onTimeDelivery.timeFrameEnd | convertToDate }}</span>
        </div>
        <div class="item-cell rate" :class="{abnormal: !onTimeDelivery.completeTarget}">{{ onTimeDelivery.rate }}</div>
        <div class="item-cell">
          <span>准时交货件数：</span>
          <span>{{ onTimeDelivery.count }}</span>
        </div>
        <div class="item-cell">
          <span>已追踪货件总数：</span>
          <span>{{ onTimeDelivery.totalCount | defaultShow}}</span>
        </div>
      </div>
      <div class="detalis2"></div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertToDate } from "@/utils/date.util"

export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    onTimeDelivery: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      message: [
        "准时交货率(OTDR)是指在预计交货日期交付的所有货件占跟踪的总货件的百分比。准时交货率仅适用于卖家自行配送的订单。",
        "在确定您有资格设置的运输时间时，亚马逊会考虑准时交货率绩效，这可以让您承诺更快的交货时间并进一步转换。。",
        "亚马逊建议卖家维持高于97%的准时交货率，以便可以提供更好的客户体验，但是目前对于没有满足绩效目标的情况暂无处罚。"
      ],
    };
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  },
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  line-height: 1;
  padding-bottom: 40px;
  .title {
    padding: 20px 0;
    .rate {
      padding: 0 15px 0 20px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
    .target {
      color: #666;
      font-size: 12px;
    }
  }
  .main {
    display: flex;
    .detalis1 {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      .item-cell {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-left: 40px;
        padding-bottom: 22px;
        &.rate {
          font-size: 24px;
          color: #333;
          font-weight: 600;
          padding: 10px 0 22px 40px;
        }
        &.date {
          width: 250px;
          font-size: 12px;
          padding-left: 0;
          .day {
            padding-right: 15px;
          }
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
    .detalis2 {
      width: 30%;
      border-left: 1px solid #ccc;
    }
    .message {
      border-left: 1px solid #ccc;
      width: 40%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding-right: 26px;
      padding-left: 30px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
  }
}
</style>